import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import IBanStripe from "./IbanStripe";
import CardStripe from "./CardStripe";
import OfflinePayment from "./OfflinePayment";
import LaterPayment from "./LaterPayment";
import SuccessPayment from "./SuccessPayment";
import { getRequest } from "../../../apis/requestsApi";
import { useNavigate, useParams } from "react-router-dom";
import SubscriptionInfo from "./SubscriptionInfo";
const stripePromise = loadStripe(
  "pk_test_51NNWd5SJqEH6Tlr58TLNW3xnG28kESij2xJGsrSJ1tmrYIle6xwBLyzFJGJjC7MNS1RuwuCtsKLjs7Fs8c3kzGHW00I2PmixKn"
);

const Payment = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [type, setType] = useState("Success");
  const [paymentType, setPaymentType] = useState(false);
  const { slug } = useParams();

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    try {
      const res = await getRequest(slug);
      setData(res.result);
      setLoading(false);
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main-wrapper" style={{ marginBottom: 100 }}>
        <div className="page-wrapper" style={{ marginLeft: 0 }}>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="content container-fluid">
              {error ? (
                <h3>URL is invalid</h3>
              ) : (
                <div>
                  <h3>Payment</h3>

                  <div>
                    {type != "Success" && (
                      <>
                        <SubscriptionInfo subDetails={data.subscriptionInfo} />
                        <div className="mt-3">
                          <button
                            onClick={() => setType("Now")}
                            className={`btn btn-primary mb-3 ${
                              type == "Now" && "Active"
                            }`}
                            // className={`btn-primary btn ${
                            //   paymentType == "Card" && "Active"
                            // }`}
                          >
                            Pay Now
                          </button>{" "}
                          &nbsp;
                          <button
                            onClick={() => setType("Later")}
                            className={`btn btn-primary mb-3 ${
                              type == "Later" && "Active"
                            }`}
                            // className="btn btn-ghost btn-secondary mb-3"
                          >
                            Pay Later
                          </button>
                        </div>
                      </>
                    )}
                    {type == "Now" && (
                      <div>
                        <Elements stripe={stripePromise}>
                          <div className="mb-4">
                            <button
                              onClick={() => setPaymentType("Offline")}
                              className={`btn-primary btn btn-alt ${
                                paymentType == "Offline" && "Active"
                              }`}
                            >
                              Pay Offline
                            </button>{" "}
                            &nbsp;
                            <button
                              onClick={() => setPaymentType("Sepa")}
                              className={`btn-primary btn  btn-alt ${
                                paymentType == "Sepa" && "Active"
                              }`}
                            >
                              Pay SEPA
                            </button>
                            &nbsp;
                            <button
                              onClick={() => setPaymentType("Card")}
                              className={`btn-primary btn  btn-alt ${
                                paymentType == "Card" && "Active"
                              }`}
                            >
                              Pay Card
                            </button>
                          </div>
                          {paymentType == "Sepa" && (
                            <div className=" mb-3 p-3 bg-body rounded shadow-sm">
                              <IBanStripe
                                userName={
                                  data.subscriptionInfo.accountHolderName
                                }
                                userEmail={
                                  data.subscriptionInfo.subscribers[0].email
                                }
                                setSuccess={setType}
                                slug={slug}
                              />
                            </div>
                          )}
                          {paymentType == "Card" && (
                            <div className=" mb-3 p-3 bg-body rounded shadow-sm">
                              <CardStripe
                                userName={
                                  data.subscriptionInfo.accountHolderName
                                }
                                userEmail={
                                  data.subscriptionInfo.subscribers[0].email
                                }
                                setSuccess={setType}
                                slug={slug}
                              />
                            </div>
                          )}
                          {paymentType == "Offline" && (
                            <div className=" mb-3 p-3 bg-body rounded shadow-sm">
                              <OfflinePayment
                                userName={
                                  data.subscriptionInfo.accountHolderName
                                }
                                userEmail={
                                  data.subscriptionInfo.subscribers[0].email
                                }
                                setSuccess={setType}
                                slug={slug}
                              />
                            </div>
                          )}
                        </Elements>
                      </div>
                    )}
                    {type == "Later" && (
                      <div className=" mb-3 p-3 bg-body rounded shadow-sm">
                        <LaterPayment
                          userName={data.subscriptionInfo.accountHolderName}
                          userEmail={data.subscriptionInfo.subscribers[0].email}
                          setSuccess={setType}
                          slug={slug}
                        />
                      </div>
                    )}
                    {type == "Success" && <SuccessPayment />}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Payment;
